// extracted by mini-css-extract-plugin
export default {"songPic":"SongPicture_songPic__ixwWk"};